var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCheckyourinbox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 336,
    height: 295,
    viewBox: "0 0 336 295",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M142.729 147.857V54.1519C142.729 42.4515 126.099 34.8767 112.068 40.1889C104.949 42.8853 100.487 48.3378 100.551 54.2752L100.64 62.6879L100.942 90.8307",
    stroke: "#ABABAB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M193.005 31.7754L118.044 38.457",
    stroke: "#ABABAB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M143.005 147.857L256.066 119.599V50.4605C256.066 37.8841 245.91 27.5703 231.185 28.3741L203.089 30.8792",
    fill: "#ABABAB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M143.005 147.857L256.066 119.599V50.4605C256.066 37.8841 245.91 27.5703 231.185 28.3741L203.089 30.8792",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M211.041 293.5H187.541V137.297L211.041 131V293.5Z",
    fill: "#ABABAB"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M216.091 1.5V9.4873L202.556 10.8418L201.206 10.9766V31.0918L201.206 31.1152L203.342 100.767L195.454 101.848L194.113 31.8994L193.801 1.5H216.091Z",
    fill: "#ABABAB",
    stroke: "white",
    strokeWidth: 3
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M187.485 136.628V293.117",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M196.178 134.812V293.118",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M210.736 131.779V293.117",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3684 141.148L5.75317 139.018",
    stroke: "#ABABAB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M29.0092 158.025L24.8071 167.888",
    stroke: "#ABABAB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5586 154.41L1.5 162.955",
    stroke: "#ABABAB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M116.811 24.6994L121.642 12.9268",
    stroke: "#ABABAB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M104.238 24.6983L102.307 18.812",
    stroke: "#ABABAB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M129.77 27.3701L136.779 22.3174",
    stroke: "#ABABAB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M137.444 93.5H64.5413V142.1H137.444V93.5Z",
    fill: "#0E4723"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M63.7869 94.9771L98.7903 129.895L136.417 94.9771",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M138.256 142.663L114.069 115.928",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M59.5968 143.435L82.7253 117.325",
    stroke: "white",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M140.79 140.5H47.2925C46.8776 140.5 46.5413 140.851 46.5413 141.284V147.716C46.5413 148.149 46.8776 148.5 47.2925 148.5H140.79C141.205 148.5 141.541 148.149 141.541 147.716V141.284C141.541 140.851 141.205 140.5 140.79 140.5Z",
    fill: "#ABABAB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckyourinbox);
export default __webpack_public_path__ + "static/media/Check your inbox.0384c87d7c41d09d314d435abed34d37.svg";
export { ForwardRef as ReactComponent };